import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { variants, Row } from './StickyCTATotalsContentRow';
import { replaceTokensInString } from '@app/utils';
import { useCatCreditsTotals } from './useStickyCTACatCreditsTotals';
import { CAT_CREDIT } from '@app/constants/commonConstants';

export const CatCreditsSection = ({
  catCreditTotal,
  orderRemainingPaymentAmount
}) => {
  const [t] = useTranslation();
  const catCreditData = useCatCreditsTotals({
    catCreditTotal,
    orderRemainingPaymentAmount
  });
  const creditsLabel = replaceTokensInString(
    t('APPLIED_CAT_CREDITS'),
    CAT_CREDIT
  );
  return (
    catCreditData.showCatCredit && (
      <>
        <Row
          label={creditsLabel}
          amount={catCreditData.creditTotalsValue}
          variant={variants.CAT_CREDITS}
          className="mt-1"
        />
        <Row
          amount={catCreditData.creditSubValue}
          variant={variants.CAT_CREDITS_SUB}
          currency={catCreditData.accountCurrencyCode}
          className="mb-1"
        />
        <Row
          label={t('AMOUNT_REMAINING')}
          forceDisplay
          amount={catCreditData.remainingAmount}
        />
        <Row
          amount={catCreditData.remainingAmountSub}
          variant={variants.AMOUNT_REMAINING_SUB}
          currency={catCreditData.accountCurrencyCode}
          className="mb-1"
        />
      </>
    )
  );
};

CatCreditsSection.propTypes = {
  catCreditTotal: PropTypes.string,
  orderRemainingPaymentAmount: PropTypes.string
};
